import React, { useContext, useState } from "react";
import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  simplyClick,
  validateAge,
} from "../../helpers";
import ButtonSubmit from "../buttonSubmit";

import "./birthdayForm.scss";
import { errorEventsBirthday } from "../../constants";
import { ContextProfileUser } from "../../lib/profileContext";
import ProgressDots from "../ProgressDots";

function BirthdayForm({ nextStep }) {
  const [errorDate, setErrorDate] = useState(null);
  const { data, setData } = useContext(ContextProfileUser);

  const birthdayData = {
    month: data.month || "",
    day: data.day || "",
    year: data.year || "",
  };

  const handlerSubmit = (e) => {
    e.preventDefault();
    const {
      error,
      status,
      errors = {},
    } = validateAge(birthdayData.month, birthdayData.day, birthdayData.year);

    const dateKey = [
      birthdayData.month ? "M" : "",
      birthdayData.day ? "D" : "",
      birthdayData.year ? "Y" : "",
    ].join("");

    if (!birthdayData.day && !birthdayData.month && !birthdayData.year) {
      simplyClick("err_lnd_age_nodate");
    }

    if (errorEventsBirthday[dateKey]) {
      simplyClick(errorEventsBirthday[dateKey]);
    }

    if (!status) {
      setErrorDate(error);
      return;
    }

    if (errors.invalidDate) {
      setErrorDate(error);
      return;
    }

    setData({
      ...data,
      birthday: getBirthdayInFormat(
        birthdayData.year,
        birthdayData.month,
        birthdayData.day,
      ),
    });

    simplyClick("cl_lnd_date_birth_next", {
      text: getBirthdayInFormat(
        birthdayData.year,
        birthdayData.month,
        birthdayData.day,
      ),
    });

    nextStep();
  };

  const handleAddMonth = (e) => {
    setErrorDate(null);
    setData({ ...data, month: e.target.value });
    simplyClick("cl_lnd_date_birth_month_choose");
  };

  const handleAddDay = (e) => {
    setErrorDate(null);
    setData({ ...data, day: e.target.value });
    simplyClick("cl_lnd_date_birth_day_choose");
  };

  const handleAddYear = (e) => {
    setErrorDate(null);
    setData({ ...data, year: e.target.value });
    simplyClick("cl_lnd_date_birth_year_choose");
  };

  return (
    <div className="promo__wrapper-birthday">
      <div className="user__form-top">
        <h3>My date of birth</h3>
      </div>
      <form className="form__date" onSubmit={handlerSubmit}>
        <div className="date__wrapper">
          <div className={`date__wrapper-select aqa-test-month${errorDate ? " error" : ""}`}>
            <select
              className={birthdayData.month ? "active" : ""}
              onChange={(e) => handleAddMonth(e)}
              value={birthdayData.month !== "" ? birthdayData.month : "default"}
            >
              <option value="default" disabled hidden>
                Month
              </option>
              {getMonths().map((item, index) => (
                <option key={index} value={index}>
                  {item || ""}
                </option>
              ))}
            </select>
          </div>
          <div className={`date__wrapper-select aqa-test-day${errorDate ? " error" : ""}`}>
            <select
              className={birthdayData.day ? "active" : ""}
              onChange={(e) => handleAddDay(e)}
              value={birthdayData.day !== "" ? birthdayData.day : "default"}
            >
              <option value="default" disabled hidden>
                Day
              </option>
              {getDate().map((item, index) => (
                <option key={index} value={item}>
                  {item || ""}
                </option>
              ))}
            </select>
          </div>
          <div className={`date__wrapper-select aqa-test-year${errorDate ? " error" : ""}`}>
            <select
              className={birthdayData.year ? "active" : ""}
              onChange={(e) => handleAddYear(e)}
              value={birthdayData.year !== "" ? birthdayData.year : "default"}
            >
              <option value="default" disabled hidden>
                Year
              </option>
              {getYears().map((item, index) => (
                <option key={index} value={item}>
                  {item || ""}
                </option>
              ))}
            </select>
          </div>
        </div>

        {errorDate && <p className="errorDate">{errorDate}</p>}
        <div className={"birthday_confirm"}>
          By proceeding, you confirm you are at least 18 years old and fully legally capable of using our website
        </div>

        <ButtonSubmit
          className={"button__global button__birthday"}
          text={"NEXT"}
        />

        <ProgressDots active={3} />
      </form>
    </div>
  );
}

export default BirthdayForm;
